/**
 * Server-side ai_agent_v2 nodes get a compiled `_meta` task graph attached via
 * a background task in config-service after each save. This helper used to poll
 * the server-side readiness endpoint (`/phlo/:id/meta-status`) before launching
 * the playground, so the first test-after-edit wouldn't race the compile and
 * silently fall back to the free-form path.
 *
 * TEMPORARILY DISABLED (~1 month): the server-side meta compiler is turned off
 * ("compiler disabled (patch)"), so `/meta-status` always reports `failed`.
 * With the compiler off, the wait only delayed the playground and logged a
 * false-positive "detected failed meta compile" error to Sentry on every
 * test-after-edit. While the compiler is off we short-circuit to "ready" and
 * let the playground start (calls run on the v2 free-form path regardless).
 *
 * Restore the polling implementation from git history when the compiler is
 * re-enabled, so the readiness gate and real compile-failure surfacing return.
 */
export interface MetaStatusNode {
  uuid: string
  name: string
  status?: string
  error?: string | null
  [key: string]: unknown
}

export interface MetaStatusResponse {
  ready?: boolean
  pending?: MetaStatusNode[]
  total_ai_nodes?: number
  status?: string
  failed?: MetaStatusNode[]
  error?: string | null
}

export interface WaitForMetaReadyOptions {
  timeoutMs?: number
}

export interface WaitForMetaReadyResult {
  ready: boolean
  timedOut: boolean
  failed: boolean
  elapsedMs: number
}

export const waitForMetaReady = (
  _phloId: string,
  _options: WaitForMetaReadyOptions = {},
): Promise<WaitForMetaReadyResult> =>
  // Wait disabled while the server meta compiler is off (see file header).
  Promise.resolve({ ready: true, timedOut: false, failed: false, elapsedMs: 0 })
